import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { Language } from 'shared/paths';
import { getDiseasePath } from 'shared/utils/get-disease-path';
import { CanonicalService } from './canonical.service';
import { DiseaseService } from './disease.service';

const GARD_ORIGIN = 'https://rarediseases.info.nih.gov';

@Injectable({
    providedIn: 'root',
})
export class MetaResolver {
    constructor(private diseaseService: DiseaseService, private meta: Meta, private title: Title, private canonical: CanonicalService) {}

    resolve(route: ActivatedRouteSnapshot) {
        const disease = this.diseaseService.disease;

        if (disease && route.data.language === Language.En && route.paramMap.has('diseaseId')) {
            const diseasePath = getDiseasePath({ id: disease.id, name: disease.name }).join('/');
            this.canonical.setUrl(`${GARD_ORIGIN}/${diseasePath}`);
        } else {
            this.canonical.remove();
        }

        if (route.data.meta) {
            if (disease) {
                const diseaseName = disease.name;
                const metaDescription = route.data.meta.description?.replace('{diseaseName}', diseaseName) || '';
                const pageTitle = route.data.meta.title?.replace('{diseaseName}', diseaseName) || '';
                this.meta.updateTag({ name: 'description', content: metaDescription });
                this.title.setTitle(pageTitle);
            } else {
                this.meta.updateTag({ name: 'description', content: route.data.meta.description });
                this.title.setTitle(route.data.meta.title);
            }
        }
        return true;
    }
}
